export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  let windowSize = window.matchMedia('(max-width: 799px)');

  function removeLinkMobile(data, x) {
    const widgetData = data.items[x];
    if (windowSize.matches && widgetData.URL === null) {
      $(this).removeAttr('href');
      $(this).removeAttr('target');
    }
  }

  function changeTitle(item) {
    const title = item.find('.card-widget-title');
    const titleText = title.text();
    title.attr('title', titleText);
    item.append(title);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      if (data.items.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName}`).append(
          '<div class="announcer aos-init aos-animat" data-aos="fade-left" data-aos-easing="ease-in-out" data-aos-duration="200" data-aos-once="false" data-aos-delay="200"></div>',
        );
        const card = $(`#${widgetName} .card-widget-item`);
        card.each(function (x) {
          const item = $(this);
          changeTitle(item);
          removeLinkMobile(data, x);
        });
        applyAOS(card, 'fade-left');
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: windowSize.matches ? ['all'] : [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
